import {SearchApiResponse} from '../../model/search';

export type SearchStateModel = SearchApiResponse & { loading: boolean; query: string; };

export const initialState: SearchStateModel = {
  loading: false,
  query: '',
  answer: '',
  results: [],
  groupedResults: {},
  context: [],
};
